module.exports = __webpack_public_path__ + "static/media/HilosMin.e6149e13.jpg";